import { useHover } from "@react-aria/interactions";
import { useStore } from "zustand";
import PropTypes from "prop-types";
import { mergeStyles } from "@react-spectrum/s2";

import { store } from "../store";

import { style } from "@react-spectrum/s2/style" with { type: "macro" };

const hoverStyles = style({
  // size: "full",
  position: "absolute",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  borderRadius: {
    size: {
      S: "sm",
      M: "default",
      L: "lg",
      XL: "xl",
      default: "lg",
    },
  },
  overflow: "hidden",
  outlineWidth: 2,
  outlineOffset: -2,
  outlineStyle: "solid",
  outlineColor: {
    default: "transparent",
    allowsOutline: {
      default: "gray-300",
      isHovered: {
        isEmphasized: "blue-600",
        default: "gray-600",
      },
    },
  },
  backgroundColor: {
    isTinted: {
      colorScheme: {
        light: "white/65",
        dark: "black/65",
      },
    },
    default: "transparent",
  },
  opacity: {
    isHovered: 1,
    default: 0,
  },
  // visibility: {
  //   renderBehavior: {
  //     always: {
  //       isHovered: "visible",
  //       default: "hidden",
  //     },
  //     hover: "visible",
  //   },
  // },
  transition: "[all]",
  transitionDuration: 300,
  willChange: "[opacity, outlineColor]",
});

export const HoverState = ({
  children,
  showOutline = true,
  isEmphasized,
  isTinted,
  renderBehavior = "hover",
  size = "L",
  styles,
}) => {
  const { hoverProps, isHovered } = useHover({});
  const colorScheme = useStore(store, (state) => state.colorScheme);

  return (
    <div
      {...hoverProps}
      className={mergeStyles(
        hoverStyles({
          isHovered,
          size,
          allowsOutline: showOutline,
          isEmphasized,
          isTinted,
          renderBehavior,
          colorScheme,
        }),
        styles,
      )}
    >
      {typeof children === "function"
        ? children({ isHovered })
        : renderBehavior === "always" || isHovered
          ? children
          : null}
    </div>
  );
};

HoverState.propTypes = {
  children: PropTypes.node,
  showOutline: PropTypes.bool,
  isEmphasized: PropTypes.bool,
  isTinted: PropTypes.bool,
  renderBehavior: PropTypes.oneOf(["hover", "always"]),
  size: PropTypes.oneOf(["S", "M", "L", "XL"]),
  styles: PropTypes.object,
};
